import { jsxs as e, Fragment as l, jsx as C } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ e(l, { children: [
  /* @__PURE__ */ C(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.25 2C5.00736 2 4 3.00736 4 4.25V19.25C4 20.4926 5.00736 21.5 6.25 21.5H17.25C18.4926 21.5 19.5 20.4926 19.5 19.25V6H15V2H6.25ZM9.53033 8.46967C9.23744 8.17678 8.76256 8.17678 8.46967 8.46967C8.17678 8.76256 8.17678 9.23744 8.46967 9.53033L10.9393 12L8.46967 14.4697C8.17678 14.7626 8.17678 15.2374 8.46967 15.5303C8.76256 15.8232 9.23744 15.8232 9.53033 15.5303L12 13.0607L14.4697 15.5303C14.7626 15.8232 15.2374 15.8232 15.5303 15.5303C15.8232 15.2374 15.8232 14.7626 15.5303 14.4697L13.0607 12L15.5303 9.53033C15.8232 9.23744 15.8232 8.76256 15.5303 8.46967C15.2374 8.17678 14.7626 8.17678 14.4697 8.46967L12 10.9393L9.53033 8.46967Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ C(
    "path",
    {
      d: "M17.586 2.58601C17.2109 2.21094 16.702 2 16.1716 2H16V5H19.4728C19.4047 4.59123 19.2105 4.21053 18.9138 3.91376L17.586 2.58601Z",
      fill: "currentColor"
    }
  )
] });
export {
  o as default
};
